/**
 * components/print/PerLineCollyDialog.js
 * Colly capture for documents that need one free-text colly field per transaction line,
 * writing `lines[i].collyNo` — shared by the Checklist (PRD §6, §5.6 — pusat only) and Invoice
 * Cabang (PRD §6). This is `PengepakanModal`'s old "No. Colly per Barang" card, lifted as-is
 * into its new home (T2c-2 retires that component; this dialog is one of the two places its
 * fields moved to). NOT `SuratJalanDialog`'s row editor — different data shape:
 * per-transaction-line here, not per-shipment-row. Standard app-modal shell, same as
 * `SuratJalanDialog.js`.
 */
import React, { useState } from "react";
import { useModalEsc } from "../../utils/modalStack";

export default function PerLineCollyDialog({ txn, items, title, onSubmit, onClose }) {
  const byCode = new Map(items.map((it) => [it.internalCode, it]));
  const [lines, setLines] = useState(() => (txn.lines || []).map((l) => ({ ...l })));

  useModalEsc(onClose);

  const setLineColly = (i, val) => setLines((ls) => ls.map((l, idx) => (idx === i ? { ...l, collyNo: val } : l)));

  const submit = (e) => {
    e.preventDefault();
    const newLines = lines.map((l) => ({
      ...l,
      collyNo: l.collyNo != null && String(l.collyNo).trim() !== "" ? String(l.collyNo).trim() : null,
    }));
    // txn.packing passed through UNCHANGED — this dialog never touches suratJalanRows, so
    // saving here can never clobber a Surat Jalan already saved for the same transaction.
    onSubmit({ lines: newLines, packing: txn.packing });
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <form className="modal-box" onSubmit={submit}>
        <h2 className="modal-title">{title}</h2>
        <div className="page-sub mono" style={{ marginBottom: 14 }}>
          {txn.invoiceNumber || txn.supplierInvoiceNo || txn.id}
        </div>

        <div className="card">
          <div className="card__title">No. Colly per Barang</div>
          {lines.map((l, i) => (
            <div className="form-row" key={i}>
              <label className="form-label">{l.name || byCode.get(l.internalCode)?.name || l.internalCode}</label>
              <input className="form-input" value={l.collyNo ?? ""} onChange={(e) => setLineColly(i, e.target.value)} />
            </div>
          ))}
        </div>

        <div className="modal-actions">
          <button type="button" className="btn" onClick={onClose}>Batal</button>
          <button type="submit" className="btn btn-primary">Simpan &amp; Cetak</button>
        </div>
      </form>
    </div>
  );
}
